export default "__VITE_ASSET__Vhy4JyTY__"